var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2804 15.4019L7.14019 20.5421L2 15.4019H12.2804Z",
    fill: "#65C1C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0462 5.86919C14.9434 3.76639 12.6537 4.51405 11.5322 5.63555C10.6444 6.5234 10.1303 7.69162 10.364 8.53274L5.83127 4.00003L3.40137 6.42994L12.3733 15.4019H17.1864L13.9621 12.1776C12.2799 10.4486 12.2331 9.56078 13.0743 8.71966C13.8687 7.92527 14.8032 8.43928 16.4388 10.0281L19.6163 13.2056L21.9995 10.8225L17.0462 5.86919Z",
    fill: "#393E47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.410297d88e3675da5a573cfe7bff13b8.svg";
export { ForwardRef as ReactComponent };